const BOOTSTRAP_KEY = "clk-user-bootstrap";

function workspaceId(value) {
	if (value == null) {
		return null;
	}
	if (typeof value === "object") {
		return value.id ?? null;
	}
	return value;
}

/** Cache a lightweight user snapshot for instant app shell after landing → dashboard. */
export function saveUserBootstrap(user) {
	if (typeof window === "undefined" || !user?.id) {
		return;
	}
	try {
		sessionStorage.setItem(
			BOOTSTRAP_KEY,
			JSON.stringify({
				id: user.id,
				name: user.name,
				email: user.email,
				profile_image: user.profile_image,
				current_workspace: workspaceId(user.current_workspace),
				isAdmin: user.isAdmin,
				isAgent: user.isAgent,
				isCustomer: user.isCustomer,
				workspaces: Array.isArray(user.workspaces)
					? user.workspaces.map((w) => ({
						id: w.id,
						name: w.name,
						title: w.title,
					}))
					: [],
			})
		);
	} catch {
		// ignore quota / private mode
	}
}

export function readUserBootstrap() {
	if (typeof window === "undefined") {
		return null;
	}
	try {
		const raw = sessionStorage.getItem(BOOTSTRAP_KEY);
		if (!raw) {
			return null;
		}
		const parsed = JSON.parse(raw);
		return parsed?.id ? parsed : null;
	} catch {
		return null;
	}
}

export function clearUserBootstrap() {
	if (typeof window === "undefined") {
		return;
	}
	try {
		sessionStorage.removeItem(BOOTSTRAP_KEY);
	} catch {
		// ignore
	}
}
